/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useState } from 'react';

import type { EmbeddedContentProps } from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedContent';
import EmbeddedLink from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedLink';
import RenderPreviewShell from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewShell';
import RenderPreviewTitle from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewTitle';
import type { RenderPreviewAvailability } from 'bundles/compound-assessments/lib/utils/renderPreviewUtils';
import { getRenderPreviewAvailability } from 'bundles/compound-assessments/lib/utils/renderPreviewUtils';

const styles = {
  renderContainer: () => css`
    min-height: 500px;
    height: 52vh;
    margin: var(--cds-spacing-200) 0;
    display: flex;
    flex-direction: column;
  `,
};

export const EmbeddedPdf: React.FC<EmbeddedContentProps> = ({ url, title }: EmbeddedContentProps) => {
  const [loading, setLoading] = useState(true);
  const [previewAvailability, setPreviewAvailability] = useState<RenderPreviewAvailability | null>(null);

  useEffect(() => {
    const checkFileAvailability = async () => {
      const previewAvailabilityResponse = await getRenderPreviewAvailability(url);
      setPreviewAvailability(previewAvailabilityResponse);
      setLoading(false);
    };

    if (loading && !previewAvailability) {
      checkFileAvailability();
    }
  }, [loading, previewAvailability, url]);

  return (
    <div>
      <EmbeddedLink url={url} title={title} />
      <RenderPreviewShell
        loading={loading}
        fileAvailable={!!previewAvailability?.fileAvailable}
        validFileSize={!!previewAvailability?.validFileSize}
      >
        <div css={styles.renderContainer}>
          <RenderPreviewTitle />
          <iframe
            src={url}
            title={title}
            width="100%"
            height="100%"
            frameBorder={0}
            allowFullScreen={true}
            loading="lazy"
          />
        </div>
      </RenderPreviewShell>
    </div>
  );
};

export const isEmbeddedPdf = (url: string) => {
  const regex = /\.(pdf)$/i;
  return url.match(regex);
};

export default EmbeddedPdf;
